module.exports = __webpack_public_path__ + "static/media/Bupa Hong Kong Icon.fedd9d64.png";